import { render, staticRenderFns } from "./CohortPlots.vue?vue&type=template&id=2ecce3bb&"
import script from "./CohortPlots.vue?vue&type=script&lang=js&"
export * from "./CohortPlots.vue?vue&type=script&lang=js&"
import style0 from "./CohortPlots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports